<template>
  <div class="ipDetails" style="margin: 0; position: relative">
    <div
      v-if="isLoading"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(255, 255, 255, 0.6);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      "
    >
      <div style="margin-bottom: 1rem; font-size: 1.2rem">Loading...</div>
      <div class="loader-circle"></div>
    </div>
    <vs-popup class="holamundo" title="Room Details" :active.sync="popupActivo">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full" style="padding-top: 2%">
              <span class="popup_lbl inputStyles">Room Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <select
                v-model="categoryId"
                name="Category"
                class="vs-select--input myselect"
                style="height: 36px"
                @change="searchRoomDetails"
              >
                <!-- <select v-model="categoryId" name="Category" class="vs-select--input myselect"
        @change="searchRoomDetails">-->

                <option
                  class="vs-component"
                  v-for="(item, index) in roomType"
                  v-bind:key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full" style="padding-top: 2%">
              <span class="popup_lbl inputStyles">Room Status</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <select
                v-model="statusType"
                name="Category"
                class="vs-select--input myselect"
                style="height: 36px"
                @change="searchRoomDetails"
              >
                <option
                  class="vs-component"
                  v-for="(item, index) in roomStatus"
                  v-bind:key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div>
        <vs-row vs-w="12">
          <vs-col
            v-for="(item, index) in roomDetails"
            v-bind:key="index"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
          >
            <vs-row>
              <vs-col>
                <div class="text-center example ex1">
                  <label class="radio red" @click="storeDetails(item)">
                    <input
                      type="radio"
                      name="group1"
                      :value="item.roomId"
                      v-model="item.roomId"
                    />
                    <span>
                      <h5>{{ item.catagory }}</h5>
                      <p>RoomNo:{{ item.roomNo }}</p>
                      <p>Rate:{{ item.rate }}</p>
                      <!-- <div v-if="item.status == 'Booked'">
                                                <p>Status:{{item.status}}</p>
                                            </div> -->
                      <p>Status:{{ item.status }}</p>
                    </span>
                  </label>
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col>
            <div style="margin-top: 2%" v-if="roomDetails.length">
              <vs-pagination
                :total="totalRecord"
                v-model="currentx"
                @change="searchRoomDetails"
              ></vs-pagination>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <div style="margin: 0">
      <vs-card
        style="
          padding: 0 !important;
          margin: 0 !important;
          min-height: calc(100vh - 80px);
          display: flex;
          flex-direction: column;
        "
      >
        <vs-row
          style="
            background: linear-gradient(
              118deg,
              rgba(var(--vs-primary), 1),
              rgba(var(--vs-primary), 0.7)
            );
            padding: 10px 12px !important;
            margin: 0 important;
            display: flex;
            align-items: center;
          "
        >
          <vs-col class="w-1/2">
            <h4 style="margin-left: 14%; color: white; padding: 0">IP</h4>
          </vs-col>
          <vs-col class="w-1/2">
            <div style="margin-left: 90%; cursor: pointer">
              <feather-icon
                icon="XIcon"
                style="color: white"
                class="custom-class"
                title="close"
                @click="exit"
              ></feather-icon>
            </div>
          </vs-col>
        </vs-row>
        <vs-divider style="margin-top: 0"></vs-divider>
        <div
          style="
            flex: 1;
            padding: 16px 4% 24px 4%;
            overflow-y: auto;
            overflow-x: hidden;
          "
        >
          <vs-row>
            <vs-alert
              color="danger"
              icon-pack="feather"
              icon="icon-info"
              v-for="(errors, err) in errorMessage"
              v-bind:key="err"
            >
              <span>{{ errors }}</span>
            </vs-alert>
            <vs-alert
              color="danger"
              icon-pack="feather"
              icon="icon-info"
              v-for="error in errors.all()"
              v-bind:key="error"
            >
              <span>{{ error }}</span>
            </vs-alert>
          </vs-row>

          <vs-row style="margin-left: 2%">
            <!-- Left Column: ip No. + Patient Details -->
            <vs-col vs-lg="6" vs-sm="12" class="pr-2 pl-4">
              <vs-row class="mb-3" style="margin-top: 2%">
                <vs-col>
                  <vs-row class="mb-1">
                    <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="topPad">
                      <span class="inputStyles">Ip No</span>
                    </vs-col>
                    <vs-col vs-lg="3" vs-md="6" vs-sm="12">
                      <vs-input
                        class="w-full"
                        readonly
                        type="text"
                        v-model="ipData.ipNo"
                      />
                    </vs-col>
                    <vs-col
                      vs-lg="1"
                      vs-md="2"
                      vs-sm="2"
                      class="p-0"
                      style="display: flex; align-items: center"
                    >
                      <div v-if="iconSearch" title="Search">
                        <SearchIcon
                          title="Search"
                          style="
                            margin-top: 5px;
                            cursor: pointer;
                            width: 20px;
                            height: 20px;
                          "
                          @click="goToIPDashboard"
                        />
                      </div>
                    </vs-col>
                    <vs-col
                      vs-lg="1"
                      vs-md="2"
                      vs-sm="2"
                      class="p-0"
                      style="
                        display: flex;
                        align-items: center;
                        margin-left: -15px;
                      "
                    >
                      <div v-if="showRefreshIcon" title="Clear">
                        <RefreshCwIcon
                          style="
                            margin-top: 5px;
                            cursor: pointer;
                            width: 18px;
                            height: 18px;
                          "
                          @click="clearAllFields"
                          title="Clear All Fields"
                        />
                      </div>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
              <div style="margin-top: 3%">
                <!-- Patient Details component -->
                <patient-details
                  :patientId="patientId"
                  :patientDetails="patientDetails"
                  :showSearchIcon="showSearchIcon"
                  :showAddIcon="showAddIcon"
                  @fetchPatient="onFetchPatient"
                  source-type="ip"
                />
              </div>
              <vs-row class="mb-3" style="margin-top: 1%">
                <vs-col>
                  <vs-row class="mb-1">
                    <vs-col vs-lg="3" class="topPad">
                      <span class="inputStyles">Full Address</span>
                    </vs-col>
                    <vs-col vs-lg="5" vs-md="12" vs-sm="12" class="topPad">
                      <vs-textarea
                        rows="3"
                        name="FullAddress"
                        v-model="ipData.fullAddress"
                        placeholder="Enter full address"
                      />
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="12" class="pl-2">
              <vs-row class="mb-3" style="margin-top: 2%; align-items: center">
                <vs-col vs-lg="3" vs-md="4" vs-sm="12" class="topPad">
                  <span class="inputStyles">Ip Date</span>
                </vs-col>
                <vs-col vs-lg="9" vs-md="8" vs-sm="12" class="topPad">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      gap: 15px;
                      flex-wrap: wrap;
                    "
                  >
                    <vs-input
                      v-model="ipData.ipDate"
                      type="date"
                      v-validate="'required'"
                      name="IpDate"
                      style="width: 200px"
                    />

                    <vs-input
                      v-model="ipData.ipTime"
                      type="time"
                      v-validate="'required'"
                      name="IpTime"
                      style="width: 130px"
                    />
                  </div>
                </vs-col>
              </vs-row>

              <vs-row class="mb-2" style="align-items: center">
                <vs-col vs-lg="3" vs-md="4" vs-sm="12" class="topPad">
                  <span class="inputStyles"></span>
                </vs-col>

                <!-- Field column (same as Ip Date field container) -->
                <vs-col vs-lg="9" vs-md="8" vs-sm="12" class="topPad">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      gap: 15px;
                      flex-wrap: wrap;
                    "
                  >
                    <!-- Checkbox -->
                    <vs-checkbox
                      v-model="fromOp"
                      class="inputStyles"
                      @click="getOpNumber"
                      style="width: 190px"
                      >From OP
                    </vs-checkbox>

                    <!-- Op No input starts exactly where Ip Time starts -->
                    <vs-input
                      readonly
                      name="OpNo"
                      v-model="ipData.opId"
                      style="width: 130px"
                    />
                  </div>
                </vs-col>
              </vs-row>

              <vs-row class="mb-2">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Consulting Doctor *</span>
                </vs-col>
                <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="topPad">
                  <select
                    v-model="ipData.doctorId"
                    @change="doctorOnChange(ipData.doctorId)"
                    class="vs-select--input myselect"
                    v-validate="'required'"
                    name="Doctor"
                    style="width: 200px"
                  >
                    <option
                      v-for="(item, index) in doctorList"
                      v-bind:key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </vs-col>
              </vs-row>

              <vs-row class="mb-2">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Referring Doctor</span>
                </vs-col>
                <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="topPad">
                  <select
                    v-model="ipData.referringDoctorId"
                    class="vs-select--input myselect"
                    name="RefDoctor"
                    style="width: 200px"
                  >
                    <option
                      v-for="(item, index) in doctorList"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </vs-col>
              </vs-row>

              <vs-row class="mb-2">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Room Details</span>
                </vs-col>

                <vs-col vs-lg="9" vs-md="8" vs-sm="12" class="topPad">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      gap: 15px;
                      flex-wrap: wrap;
                    "
                  >
                    <!-- Select/Change Room Button -->
                    <vs-button
                      color="primary"
                      type="border"
                      @click="selectRooms"
                      style="width: 200px"
                    >
                      {{ show ? "Change Room" : "Select Room" }}
                    </vs-button>

                    <!-- Room No Input -->
                    <vs-input
                      readonly
                      :value="roomNo + ' ' + roomCategory"
                      name="RoomNo"
                      style="width: 130px"
                      placeholder="Room No"
                    />
                  </div>
                </vs-col>
              </vs-row>

              <vs-row class="mb-2">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Admission Category *</span>
                </vs-col>
                <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="topPad">
                  <select
                    v-model="ipData.admissionCategoryId"
                    class="vs-select--input myselect"
                    name="admissionCategoryId"
                    style="width: 200px"
                    v-validate="'required'"
                  >
                    <option
                      v-for="(item, index) in admissionList"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </vs-col>
              </vs-row>
              <vs-row class="mb-2">
                <vs-col vs-lg="3" class="topPad">
                  <span class="inputStyles">Admission Reason *</span>
                </vs-col>
                <vs-col vs-lg="9" vs-md="12" vs-sm="12" class="topPad">
                  <vs-textarea
                    rows="3"
                    name="AdmissionReason"
                    v-model="ipData.admissionReason"
                    placeholder="Enter reason for admission"
                    style="width: 345px"
                    v-validate="'required'"
                  />
                </vs-col>
              </vs-row>
            </vs-col>
          </vs-row>
        </div>
        <!-- btn grp -->
        <!--  FOOTER -->
        <div
          style="
            padding: 28px 40px;
            min-height: 80px;
            display: flex;
            align-items: flex-end;
            background: #fff;
          "
        >
          <vs-button
            v-if="ipData.ipNo !== 'New'"
            @click="openDischarge"
            color="primary"
            style="min-width: 100px; height: 40px"
          >
            Discharge
          </vs-button>

          <div style="margin-left: auto; display: flex; gap: 6px">
            <vs-button
              color="success"
              style="min-width: 100px; height: 40px"
              :disabled="saveFlag"
              @click="saveIp"
            >
              Save
            </vs-button>

            <vs-button
              color="warning"
              style="min-width: 100px; height: 40px"
              @click="printIp"
            >
              Print
            </vs-button>

            <vs-button
              color="danger"
              style="min-width: 100px; height: 40px"
              @click="exit"
            >
              Exit
            </vs-button>
          </div>
        </div>
      </vs-card>
      <!-- <print-bill style="display:none" :patientId="patientId"  :billPrintData="BillData" :patientDetails="patientDetails"></print-bill> -->
      <print-ip
        v-show="showIp"
        style="display: none"
        :patientId="patientId"
        :doctorName="doctorName"
        :roomNo="roomNo"
        :ipPrintData="ipData"
        :patientDetails="patientDetails"
      ></print-ip>
    </div>
  </div>
  <!-- <button v-on:click="storeDetails(item)" style="border: none;height: 5%;color: grey;">
                                <vs-card actionable class="cardx">
                                
                                            <div class="vx-row mb-2">
                                                <div class="vx-col sm:w-1/2 w-full">
                                                    <span>Room No</span>
                                                </div>
                                                <div class="vx-col sm:w-1/3 w-full">
                                                    <span style="font-weight:500">{{item.roomNo}}</span>
                                                </div>
                                            </div>
                                            <div class="vx-row mb-2">
                                                <div class="vx-col sm:w-1/2 w-full">
                                                    <span>Category</span>
                                                </div>
                                                <div class="vx-col sm:w-1/3 w-full">
                                                    <span style="font-weight:500">{{item.catagory}}</span>
                                                </div>
                                            </div>
                                            <div class="vx-row mb-2">
                                                <div class="vx-col sm:w-1/2 w-full">
                                                    <span>Rate</span>
                                                </div>
                                                <div class="vx-col sm:w-1/3 w-full">
                                                    <span style="font-weight:500">{{item.rate}}</span>
                                                </div>
                                            </div>
                                            <div class="vx-row mb-2">
                                                <div class="vx-col sm:w-1/2 w-full">
                                                    <span>Status</span>
                                                </div>
                                                <div class="vx-col sm:w-1/3 w-full" v-if="item.status == 'Booked'">
                                                    <span style="color:red">{{item.status}}</span>
                                                </div>
                                                <div class="vx-col sm:w-1/3 w-full" v-if="item.status == 'Vacant'">
                                                    <span style="color:green">{{item.status}}</span>
                                                </div>
                                            </div>
                                
                                </vs-card>
                                </button> -->
  <!-- <div class=" text-center example ex1">
                                <label class="radio blue">
                                    <input type="radio" name="group2" v-model="item.roomId" />
                                    <span>
                                        <h5>{{item.catagory}}</h5>
                                        <p>RoomNo:{{item.roomNo}}</p>
                                        <p>Rate:{{item.rate}}</p>
                                        <p>Status:{{item.status}}</p>
                                    </span>
                                </label>
                        </div> -->
</template>
<script>
import { SearchIcon, RefreshCwIcon } from "vue-feather-icons";
import PatientDetails from "../components/PatientDetails.vue";
import BillingTable from "../components/BillingTable.vue";
import PrintIp from "../components/PrintIp";
import PrintBill from "../components/PrintBill.vue";
export default {
  name: "ipDetails",
  components: {
    PatientDetails,
    BillingTable,
    PrintBill,
    PrintIp,
    SearchIcon,
    RefreshCwIcon,
  },
  data() {
    return {
      roomType: [{ id: "", name: "Select" }],
      roomStatus: [
        { id: "", name: "Select" },
        { id: "Booked", name: "Booked" },
        { id: "Vacant", name: "Vacant" },
      ],
      /*ipTime: new Date().toLocaleTimeString('en-GB', {
  hour: '2-digit',
  minute: '2-digit'
}),*/

      ipData: {
        ipNo: "New",
        ipDate: new Date().toISOString().slice(0, 10),
        ipTime: new Date().toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
        }),
        opId: "",
        doctorId: 0,
        referringDoctorId: 0,
        dischargeFlag: "N",
        dischargeDate: "",
        fullAddress: "",
        admissionReason: "",
        admissionCategoryId: 0,
      },
      showIp: false,
      patientId: "",
      patientDetails: {},
      iconShow: true,
      popupActive: false,
      statusType: "",
      fromOp: false,
      opNo: "",
      doctorList: [
        {
          id: 0,
          name: "Select",
        },
      ],
      admissionList: [
        {
          id: 0,
          name: "Select",
        },
      ],
      statusList: [
        {
          id: null,
          name: "Select",
        },
      ],
      categoryList: [
        {
          id: null,
          name: "Select",
        },
      ],
      errorMessage: [],
      readonlyFlag: false,
      saveFlag: false,
      doctorFlag: false,
      printFlag: false,
      doctorName: "",
      categoryId: "",
      popupActivo: false,
      roomDetails: [],

      currentx: 1,
      limit: 6,
      curPage: 1,
      runPage: 1,
      totalRecord: "",
      roomCategory: "",
      show: false,
      roomData: {
        bookingId: "New",
        roomId: "",
        bookingDate: new Date().toISOString().slice(0, 10),
        releasedFlag: "N",
        releasedDate: "0000-00-00",
      },
      roomNo: "",
      showSearchIcon: true,
      showAddIcon: true,
      showRefreshIcon: true,
      iconSearch: true,
    };
  },
  mounted() {
    if (this.$route.query.patientId) {
      this.patientId = parseInt(this.$route.query.patientId);
      this.iconShow = false;

      // Save to Vuex
      this.$store.dispatch("updatePatientId", this.patientId);

      this.getpatientDetails();
    } else if (this.$store.state.patientId) {
      this.patientId = this.$store.state.patientId;
      this.iconShow = true;

      // Clear Vuex after reading if you want
      this.$store.dispatch("updatePatientId", "");

      this.getpatientDetails();
    }

    if (this.$route.query.IpId) {
      this.ipData.ipNo = parseInt(this.$route.query.IpId);
      this.iconShow = false;

      // Save to Vuex
      this.$store.dispatch("updateIpNo", this.ipData.ipNo);

      this.getIpDetails();
    } else if (this.$store.state.ipNo) {
      this.ipData.ipNo = this.$store.state.ipNo;
      this.$store.dispatch("updateIpNo", "");
      this.getIpDetails();
    }

    // 3️ Always fetch lists and dropdowns
    this.getDoctorList();
    this.getAdmission();
    this.getRoomCategory();

    // 4️ Clear filters if needed
    this.clearFields();
  },
  methods: {
    doctorOnChange(doctorId) {
      this.doctorList.forEach((value) => {
        if (value.id == doctorId) {
          this.doctorName = value.name;
        }
      });
    },
    exit() {
      this.$router.push("/IpDashboardView");
    },
    onFetchPatient(patientId) {
      console.log(" Received fetchPatient event with:", patientId);
      this.patientId = patientId; // update parent patientId
      this.getpatientDetails(); // fetch patient details
    },
    goToIPDashboard() {
      console.log("going to IPdashboard   ");
      this.$router.push({ name: "IP" });
    },
    getDoctorList() {
      var request = {
        companyId: this.$session.get("companyId"),
      };
      this.$http
        .post("getdoctorlist", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          response.data.data.forEach((value) => {
            this.doctorList.push(value);
          });
        });
    },
    getAdmission() {
      var request = {
        companyId: this.$session.get("companyId"),
      };
      this.$http
        .post("/getAdmissionCategories", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          response.data.data.forEach((value) => {
            this.admissionList.push(value);
          });
        });
    },
    getOpNumber() {
      var request = {
        companyId: this.$session.get("companyId"),
        patientId: this.patientId,
      };
      this.$http
        .post("/getOpNumber", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.ipData.opId = response.data.data.opNo;
        });
    },
    async getpatientDetails() {
      try {
        var request = {
          companyId: this.$session.get("companyId"),
          regNo: this.patientId,
        };
        const response = await this.$http.post(
          "getpatiententry",
          JSON.stringify(request),
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && response.data.data) {
          this.patientDetails = response.data.data;
          this.errorMessage = [];
        } else {
          this.patientDetails = {};
          this.$vs.notify({
            title: "Patient Not Found",
            text: `No patient found with ID ${this.patientId}.`,
            color: "warning",
            position: "top-right",
          });
        }
      } catch (error) {
        console.error("Error fetching patient details:", error);
        this.patientDetails = {};
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch patient details. Please try again.",
          color: "danger",
          position: "top-right",
        });
      }
    },
    getRoomCategory() {
      var request = {
        companyId: this.$session.get("companyId"),
      };
      this.$http
        .post("getRoomCategory", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.roomType.push(element);
          });
        });
    },
    selectRooms() {
      this.searchRoomDetails();
      this.popupActivo = true;
    },
    clearFields() {
      this.categoryId = "";
      this.statusType = "";
    },
    searchRoomDetails() {
      const request = {
        companyId: this.$session.get("companyId"),
        categoryId: this.categoryId,
        statusType: this.statusType,
        currentPage: this.currentx,
        pageLimit: this.limit,
      };
      // this.clearFields();

      this.$http
        .post("/searchRoomDetails", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.roomDetails = response.data.data;

          // TOTAL records from backend
          this.totalRecord = Math.ceil(response.data.recordsTotal / this.limit);
        });
    },
    storeDetails(item) {
      this.show = true;
      this.roomData.roomId = item.roomId;
      this.roomNo = item.roomNo;
      this.roomCategory = item.catagory;
      this.popupActivo = false;
      this.clearFields();
      console.log(JSON.stringify(item));
    },

    validateIp() {
      this.errorMessage = [];

      if (!this.patientId) {
        this.errorMessage.push("Patient ID is required.");
      }

      if (!this.patientDetails.name || this.patientDetails.name.trim() === "") {
        this.errorMessage.push("Patient name is required.");
      }

      if (!this.patientDetails.age || this.patientDetails.age.trim() === "") {
        this.errorMessage.push("Patient age is required.");
      }

      if (
        !this.patientDetails.gender ||
        this.patientDetails.gender.trim() === ""
      ) {
        this.errorMessage.push("Patient gender is required.");
      }
      if (Number(this.ipData.admissionCategoryId) === 0) {
        this.errorMessage.push("Admission category is required.");
      }

      if (
        !this.ipData.admissionReason ||
        this.ipData.admissionReason.trim() === ""
      ) {
        this.errorMessage.push("Admission reason is required.");
      }
      if (!this.ipData.doctorId) {
        this.errorMessage.push("Select Consulting Doctor");
        isValid = false;
      }

      return this.errorMessage.length === 0;
    },
    saveIp() {
      this.errorMessage = []; // Reset before each validation

      if (!this.validateIp()) {
        return;
      }
      this.saveFlag = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          var request = {
            companyId: this.$session.get("companyId"),
            patientId: this.patientId,
            ipData: this.ipData,
            userId: this.$session.get("userId"),
            //opId:this.opNo,
            roomId: this.roomData.roomId,
          };
          console.log(JSON.stringify(request));
          this.$http
            .post("/saveIp", JSON.stringify(request), {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // this.saveFlag = this.readonlyFlag = this.$refs.billing.readonlyFlag = true;
              this.printFlag = false;
              this.ipData.ipNo = response.data.data.ipNo;
              this.$store.dispatch("updatePatientId", this.patientId);
              this.$store.dispatch("updateIpNo", this.ipData.ipNo);

              this.saveRoom();
            })
            .catch((error) => {
              this.$vs.notify({
                title: " Error",
                text: "Error Occured Plz Try later",
                color: "danger",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-center",
              });
            })
            .finally(() => {
              this.saveFlag = false;
            });
        }
      });
    },
    saveRoom() {
      var request = {
        companyId: this.$session.get("companyId"),
        patientId: this.patientId,
        ipNo: this.ipData.ipNo,
        roomData: this.roomData,
        userId: this.$session.get("userId"),
      };
      console.log(JSON.stringify(request));
      this.$http
        .post("/saveRoom", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(response.data);
          this.saveFlag = true;
          this.printFlag = false;
          this.roomData.bookingId = response.data.data.bookingId;
          this.readonlyFlag = true;
          this.$vs.notify({
            title: "Saved Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-center",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: " Error",
            text: "Error Occured Plz Try later",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-center",
          });
        });
    },
    getIpDetails() {
      var request = {
        companyId: this.$session.get("companyId"),
        patientId: this.patientId,
        refId: this.ipData.ipNo,
      };
      this.readonlyFlag = true;

      this.$http
        .post("/getIpDetails", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.show = true;
          this.ipData = response.data.data.ipData;
          this.opNo = response.data.data.ipData.opId;
          this.doctorName = response.data.data.ipData.doctorName;

          this.roomNo = response.data.data.roomData.roomNo;
          this.roomCategory = response.data.data.roomData.category;
          this.fromOp = this.ipData.opId ? true : false;
        });
    },

    openDischarge() {
      this.$router.push({
        name: "Discharge",
        query: {
          ipNo: this.ipData.ipNo,
          patientId: this.patientId,
        },
      });
    },

    printIp() {
      this.showIp = true;
      this.$nextTick(() => {
        window.print();
        this.showIp = false;
      }, 150);
    },
    clearAllFields() {
      // Reset ipData to default
      this.ipData = {
        ipNo: "New",
        ipDate: new Date().toISOString().slice(0, 10),
        doctorId: 0,
        referringDoctorId: 0,
        dischargeFlag: "N",
        dischargeDate: "",
        fullAddress: "",
        admissionReason: "",
        admissionCategoryId: 0,
      };
      (this.ipTime = new Date().toLocaleTimeString()),
        // Reset related fields
        (this.patientId = "");
      this.patientDetails = {};
      this.opNo = "";
      this.fromOp = false;
      this.doctorName = "";
      this.roomNo = "";
      this.roomCategory = "";
      this.roomData = {
        bookingId: "New",
        roomId: "",
        bookingDate: new Date().toISOString().slice(0, 10),
        releasedFlag: "N",
        releasedDate: "0000-00-00",
      };
      this.$router.replace({ query: {} });
      // Reset dropdown selections
      this.categoryId = "";
      this.statusType = "";

      // Re-enable inputs
      this.readonlyFlag = false;
      this.saveFlag = false;
      this.printFlag = false;
      this.show = false;

      // Reload necessary dropdown data (like when mounted)
      this.getDoctorList();
      this.getAdmission();
      this.getRoomCategory();

      // Reset pagination and room details
      this.currentx = 1;
      this.roomDetails = [];

      // Notify user
      this.$vs.notify({
        title: "Cleared Successfully",
        text: "All fields have been reset to default.",
        color: "primary",
        iconPack: "feather",
        icon: "icon-refresh-cw",
        position: "top-center",
      });
    },
  },
};
</script>
<style>
.inputStyles {
  font-size: 11.8px;
  font-weight: 600;
}
.topPad {
  padding-top: 7px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: -20px;
  width: 100%;
  z-index: 500;
}
.con-vs-popup .vs-popup {
  width: 800px;
}
.example {
  margin: 20px;
}

.example input {
  display: none;
}

.example label {
  margin-right: 20px;
  display: inline-block;
  cursor: pointer;
  width: 165px;
}

.ex2 span {
  display: block;
  padding: 10px 10px 10px 10px;
  border: 2px solid #ddd;
  border-radius: 5px;
  position: relative;
  transition: all 0.25s linear;
}

.ex2 span h5 {
  padding-bottom: 5px;
}

.ex2 span:before {
  position: absolute;
  left: 5px;
  top: 50%;
  -webkit-transform: translatey(-50%);
  transform: translatey(-50%);
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ddd;
  transition: all 0.25s linear;
}

.ex2 input + span {
  background-color: #fff;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.ex2 .blue input + span {
  color: blue;
  border-color: #00ffd291;
}

.ex2 .blue input + span:before {
  background-color: blue;
}
.ex1 span {
  display: block;
  padding: 10px 10px 10px 10px;
  border: 2px solid #ddd;
  border-radius: 5px;
  position: relative;
  transition: all 0.25s linear;
}

.ex1 span h5 {
  padding-bottom: 5px;
}

.ex1 span:before {
  position: absolute;
  left: 5px;
  top: 50%;
  -webkit-transform: translatey(-50%);
  transform: translatey(-50%);
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #ddd;
  transition: all 0.25s linear;
}

.ex1 input:checked + span {
  background-color: #fff;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

.ex1 .red input:checked + span {
  color: blue;
  border-color: #00ffd291;
}

.ex1 .red input:checked + span:before {
  background-color: blue;
}
.loader-circle {
  border: 5px solid #f3f3f3;
  border-top: 5px solid rgb(25, 71, 170);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-top: 5px;
}
</style>
